/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RawProfileLayoutAliases {
  CARD_0 = 'card-0',
  CARD_1 = 'card-1',
  CARD_3 = 'card-3',
  CARD_4 = 'card-4',
  CARD_ALTERNATIVE_LOGIN = 'card-alternative-login',
  CARD_INSURANCES = 'card-insurances',
  CARD_SECURITY_AUTHENTICATION = 'card-security-authentication',
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_1 = 'fragment-1',
  FRAGMENT_3 = 'fragment-3',
  FRAGMENT_4 = 'fragment-4',
  FRAGMENT_INSURANCES = 'fragment-insurances',
  FRAGMENT_REFERENCE_0 = 'fragment-reference-0',
  FRAGMENT_SECURITY_AUTHENTICATION = 'fragment-security-authentication',
  LAYOUT_PROFILE = 'layout-profile',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_3 = 'panel-3',
  PANEL_5 = 'panel-5',
  PANEL_ALTERNATIVE_LOGIN = 'panel-alternative-login',
  PANEL_CARD_ALTERNATIVE_LOGIN_CONTROL_VISIBILITY = 'panel-card-alternative-login-control-visibility',
  PANEL_CARD_SECURITY_CONTROL = 'panel-card-security-control',
  PANEL_INSURANCES = 'panel-insurances',
  PANEL_SECURITY_AUTHENTICATION = 'panel-security-authentication',
  RAW_PANEL_PROFILE = 'raw-panel-profile',
  RAW_PROFILE_LAYOUT = 'raw-profile-layout',
}
export { RawProfileLayoutAliases };
